import { Box, HStack, Progress, Text, useToast } from "@chakra-ui/react";
import React, { useCallback, useEffect, useRef, useState } from "react";
import cr from "../../lib/request";
import { SilabusUploadProccess } from "../../const/types";
import useTrigger from "../../globalState/useTrigger";
import useSilabusUploadProccesses from "../../globalState/useSilabusUploadProcesses";
import useDataChanges from "../../globalState/useDataChanges";

type Props = {
  silabusUploadProccess: SilabusUploadProccess;
  setSilabusUploadProccesses: (newData: any) => void;
};

export default function SilabusUploadProccessItem({
  silabusUploadProccess,
  setSilabusUploadProccesses,
}: Props) {
  const [progress, setProgress] = useState<number>(0);
  const progressRef = useRef<number>(0);

  const toast = useToast();

  const { trigger, setTrigger } = useTrigger();
  const { setDataChanges } = useDataChanges();

  const { silabusUploadProccesses } = useSilabusUploadProccesses();
  const silabusUploadProccessesRef = useRef(silabusUploadProccesses);

  const setSilabusUploadProccessesCallback = useCallback(
    (newSilabusUploadProccesses: any) => {
      setSilabusUploadProccesses(newSilabusUploadProccesses);
    },
    [setSilabusUploadProccesses]
  );

  useEffect(() => {
    let url;
    if (silabusUploadProccess.status === "tambah") {
      url = `api/subcourse/savesubcourse`;
    } else {
      url = `api/subcourse/${silabusUploadProccess.data_id}/updatesubcourse`;
    }

    cr.post(url, silabusUploadProccess.payload, {
      onUploadProgress: (progressEvent) => {
        if (progressEvent.total) {
          const newProgress = Math.round(
            (progressEvent.loaded / progressEvent.total) * 100
          );

          const realProgress =
            newProgress > progressRef.current
              ? newProgress
              : progressRef.current;

          setProgress(realProgress);
          progressRef.current = realProgress;
        }
      },
    })
      .then((r) => {
        if (silabusUploadProccess.status === "tambah") {
          if (r.status === 201) {
            toast({
              title: r?.data?.message,
              status: "success",
              duration: 5000,
              isClosable: true,
            });
            setTrigger(!trigger);
            setDataChanges(r.data.data.id);
          }
        } else {
          if (r.status === 200) {
            toast({
              title: r?.data?.message,
              status: "success",
              duration: 5000,
              isClosable: true,
            });
            setTrigger(!trigger);
            setDataChanges(r.data.data.id);
          }
        }
      })
      .catch((e) => {
        console.log(e);
        toast({
          title: "Gagal menambahkan silabus",
          description: e?.responnse?.data?.message,
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      })
      .finally(() => {
        const newSilabusUploadProccesses =
          silabusUploadProccessesRef.current.filter(
            (uploadProcess) => uploadProcess.id !== silabusUploadProccess.id
          );
        setSilabusUploadProccessesCallback(newSilabusUploadProccesses);
      });
  }, [
    setSilabusUploadProccessesCallback,
    silabusUploadProccess.id,
    silabusUploadProccess.payload,
    silabusUploadProccess,
    setTrigger,
    toast,
  ]);

  return (
    <Box mb="2">
      <HStack justify={"space-between"} mb={4}>
        <Text noOfLines={1}>{`${silabusUploadProccess.title}`}</Text>
        <Text opacity={0.5}>{`${progress}%`}</Text>
      </HStack>

      <HStack>
        <Progress value={progress} size="md" width="100%" borderRadius={8} />

        {/* <IconButton
          size={"sm"}
          className="btn-clear"
          aria-label="Cancel Upload"
          icon={<Icon as={X} />}
          onClick={() => {
            setData((prevData) =>
              prevData.map((process) =>
                process.id === uploadProcess.id
                  ? { ...process, cancelled: true }
                  : process
              )
            );
          }}
        /> */}
      </HStack>
    </Box>
  );
}
